import { createSelector } from 'reselect';

import { RootState } from '../../types';

// @ts-expect-error легаси какое-то. нужно разобраться
export const selectAnalytics = (state: RootState) => state?.analytics;

export const selectSentEvents = createSelector(
  selectAnalytics,
  (analytics) => analytics?.sentEvents || [],
);
